export default __webpack_public_path__ + "static/media/video.cfa7d4bc.mp4";